<section class="page">
  <header class="page-header">
    <div>
      <a routerLink="/webhook-logs" class="back">← Webhook logs</a>
      <h1>Webhook log detail</h1>
      <p>Full request and processing audit for this delivery</p>
    </div>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }

  @if (loading()) {
    <div class="panel muted">Loading…</div>
  } @else {
    @if (log(); as row) {
      <div class="detail-grid">
        <div class="panel">
          <div class="panel-head">
            <h2>#{{ row.id }} · {{ row.provider }}</h2>
            <span class="badge" [attr.data-status]="row.status">{{ row.status || '—' }}</span>
          </div>
          <dl class="meta">
            <div><dt>Source</dt><dd>{{ row.log_source || '—' }}</dd></div>
            <div><dt>Event type</dt><dd>{{ row.event_type || '—' }}</dd></div>
            <div><dt>Event ID</dt><dd class="mono">{{ row.event_id || '—' }}</dd></div>
            <div><dt>Entity</dt><dd>{{ row.entity_type || '—' }} / <span class="mono">{{ row.entity_id || '—' }}</span></dd></div>
            <div><dt>Signature</dt>
              <dd>
                @if (row.signature_valid === true) { valid }
                @else if (row.signature_valid === false) { invalid }
                @else { — }
              </dd>
            </div>
            <div><dt>HTTP status</dt><dd>{{ row.response_status_code ?? '—' }}</dd></div>
            <div><dt>Error</dt><dd>{{ row.error_message || '—' }}</dd></div>
            <div><dt>SNS</dt><dd>{{ row.sns_message_type || '—' }} / <span class="mono">{{ row.sns_message_id || '—' }}</span></dd></div>
            <div><dt>Client</dt><dd class="mono">{{ row.client_id || '—' }}</dd></div>
            <div><dt>URL</dt><dd class="mono">{{ row.request_method || 'POST' }} {{ row.request_url || '—' }}</dd></div>
            <div><dt>Received</dt><dd>{{ row.received_at ? (row.received_at | date: 'medium') : '—' }}</dd></div>
            <div><dt>Processed</dt><dd>{{ row.processed_at ? (row.processed_at | date: 'medium') : '—' }}</dd></div>
          </dl>
        </div>
      </div>

      <div class="panel payload">
        <h2>Request headers</h2>
        <pre class="json">{{ pretty(row.request_headers || row.headers) }}</pre>
      </div>
      <div class="panel payload">
        <h2>Request body / payload</h2>
        <pre class="json">{{ pretty(row.request_body || row.payload) }}</pre>
      </div>
      <div class="panel payload">
        <h2>Response body</h2>
        <pre class="json">{{ pretty(row.response_body) }}</pre>
      </div>
    }
  }
</section>
